import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { IconComponent } from '@examdojo/core/icon';
import { PayoutRequestUIModel } from '@examdojo/payments';

@Component({
  selector: 'dojo-total-hourly-payout-cell-renderer',
  template: `
    <div class="flex h-full items-center gap-2">
      <span>{{ payoutAmount }}</span>
      @if (hasAppliedRate) {
        <dojo-icon [icon]="'info-circle'" [matTooltip]="rateTooltip" class="cursor-help text-gray-500" />
      }
    </div>
  `,
  imports: [IconComponent, MatTooltipModule],
})
export class TotalHourlyPayoutCellRendererComponent extends BaseCellRendererComponent<number, PayoutRequestUIModel> {
  get payoutAmount(): string {
    const amount = this.params?.data?.estimatedPayout;
    return amount ? `€${amount.toFixed(2)}` : '€0.00';
  }

  get rateTooltip(): string {
    const rate = this.params?.data?.appliedHourlyRate ?? 0;
    return `Hourly rate: €${rate.toFixed(2)}/hour`;
  }

  get hasAppliedRate(): boolean {
    return (this.params?.data?.appliedHourlyRate ?? 0) > 0;
  }
}
